import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { api, ApiError } from "@utils/index";
import { useBindingContext } from "@/apps/@components/binding-context";
import liff from "@line/liff";

const BindingActionGuard = () => {
	const location = useLocation();
  const navigate = useNavigate();
	const [isMounted, setIsMounted] = useState(false);
	const {from} = useBindingContext();
  const bindingRef = useRef(false);

  const getProfile = async () => {
		try {
			const res = await api.get("/profile");
			return res?.userProfile;
		} catch (error) {
			throw error.response?.data?.error?.code || new Error("Unknown error");
		}
	};
	
	const checkBindingStatus = async () => {
		try {
			await getProfile();
      return true;
		} catch (errorCode) {
			switch (errorCode) {
				case ApiError.USER_NOT_BINDED:
					return false;
				default:
					break;
			}
		}
	};

	useEffect(() => {
		(async () => {
      try {
        console.log("from", from);
        if (from === "sales-qrcode") {
          console.log("from sales-qrcode");
          navigate("/binding-sales");
          setIsMounted(true);
          return;
        }

        if (from === "splash-2026") {
          // 已綁定 → 直接帶回 campaign；未綁定 → 由下方 checkBindingStatus 決定流程
          const bindingResult = await checkBindingStatus();
          if (bindingResult === true) {
            console.log("from splash-2026 + already bound → back to campaign");
            navigate("/campaign/splash-2026", { replace: true });
            return;
          }
          if (bindingResult === false) {
            setIsMounted(true);
            return;
          }
        }

        if (from === "wallpaper") {
          // 已綁定 → 直接帶回桌布活動；未綁定 → 由下方 checkBindingStatus 決定流程（導去綁定頁）
          const bindingResult = await checkBindingStatus();
          if (bindingResult === true) {
            // 綁定完成會先進 /thanks，讓 ThanksPage 停留 1.5 秒再自動導往桌布首頁
            // （並在那裡送 member_bind_success 埋點）；此處不搶著導頁，避免感謝頁被跳過。
            if (location.pathname.includes("/thanks")) {
              setIsMounted(true);
              return;
            }
            navigate("/wallpaper/home", { replace: true });
            return;
          }
          if (bindingResult === false) {
            setIsMounted(true);
            return;
          }
        }

        if (bindingRef.current === false) {
          const bindingResult = await checkBindingStatus();
          if (bindingResult === true) {
            bindingRef.current = bindingResult;
          }
  
          if (bindingResult === false) {
            setIsMounted(true);
            return;
          }
        }
      }
      catch (error) {
        console.error(error);
        setIsMounted(true);
        return;
      }

      // 只在 /profile 和 /thanks 頁面執行
      if (location.pathname.includes('/binding') || location.pathname.includes('redirect')) {
        setIsMounted(true);
        return;
      }

      if (from === "1on1-chat") {
        console.log("from 1on1-chat");
        liff.closeWindow();
      }
      else if (from === 'tb-game') {
        console.log("from tb-game");
        navigate("/tb-game-redirect");
      }
      setIsMounted(true);
    })();
	}, [location, from]);

  if (!isMounted) {
    return null;
  }

	return (
		<Outlet />
	);
};

export default BindingActionGuard;
